import React, {useMemo} from "react";
import {Link} from "@montana/shared/link";
import {StrokeLine} from "@montana/shared/stroke";
import {ILevel1MenuItem} from "@montana/models/generated/cms.interface";

export interface IDesktopMenuLinkItemProps {
    item: ILevel1MenuItem;
    isSelectedItemIdInSubItems?: boolean;
    setActiveMegaMenuItem: (id: string) => void;
    onHoverItem?: (link: ILevel1MenuItem) => void;
    onUnHoverItem?: () => void;
    isHoveringOn?: ILevel1MenuItem;
    onToggleDrawerMenu: () => void
}

export const DesktopMenuLinkItem: React.FC<IDesktopMenuLinkItemProps> = React.memo(
    ({
        item,
        isHoveringOn,
        setActiveMegaMenuItem,
        isSelectedItemIdInSubItems,
        onHoverItem,
        onUnHoverItem,
        onToggleDrawerMenu
    }: IDesktopMenuLinkItemProps): JSX.Element | null => {
        const hasSubItems = useMemo(() => item.hasOwnProperty('subItems') && item.subItems && item.subItems.length > 0, [
            item
        ]);

        const isActiveItem = (item: ILevel1MenuItem) => {
            const itemName = item.link?.name;
            return isHoveringOn?.link?.name === itemName;
        };

        function handleOnClickMenuItem() {
            if (!isSelectedItemIdInSubItems && item.itemId) {
                setActiveMegaMenuItem(item.itemId);
            }
            onToggleDrawerMenu();
        }

        if (hasSubItems) {
            return (
                <button
                    onClick={handleOnClickMenuItem}
                    onMouseEnter={() => onHoverItem?.(item)}
                    onMouseLeave={() => onUnHoverItem?.()}
                >
                    <Link
                        className="desktop-menu__link"
                        key={`${item?.link?.name}-${item.itemId}`}
                    >
                        <span>
                            {item?.link?.name}
                            <StrokeLine
                                active={isActiveItem(item)}
                                inverseAnimation={true}
                            ></StrokeLine>
                        </span>
                    </Link>
                </button>
            );
        }

        return (
            <Link
                className="desktop-menu__link"
                key={`${item?.link?.name}-${item.itemId}`}
                to={item?.link?.url}
                onMouseEnter={() => onHoverItem?.(item)}
                onMouseLeave={() => onUnHoverItem?.()}
            >
                <span>
                    {item?.link?.name}
                    <StrokeLine
                        active={isActiveItem(item)}
                        inverseAnimation={true}
                    ></StrokeLine>
                </span>
            </Link>
        );
    }
);
